import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import '../css/sambutan.css'
import data from '../data/misi.json'
import Sidebar from "./sidebar";
import Copyright from "./copyright";

export default function Sambutan() {
    const [jsonData, setJsonData] = useState([]);
    useEffect(() => {
        setJsonData(jsonData);
    }, []);
    const navRef = useRef();
    const [showKepsek, setShowKepsek] = useState(true); // Mengubah nilai awal ke true
    const [showSmalabum, setShowSmalabum] = useState(false);

    // Fungsi untuk menampilkan konten Kepsek
    const showKepsekContent = () => {
        setShowKepsek(true);
        setShowSmalabum(false);
        handleClick('sambutan');
    };

    // Fungsi untuk menampilkan konten tentang SMA Lab UM
    const showSmalabumContent = () => {
        setShowSmalabum(true);
        setShowKepsek(false);
        handleClick('tentang');
    };


    const [activeMenu, setActiveMenu] = useState(null);

    const handleClick = (menu) => {
        setActiveMenu(menu === activeMenu ? null : menu);
    };

    return (
        <>
            <section className="cover-sambutan">
                <div className="d-lg-flex d-md-flex justify-content-between align-items-start">
                    <div className="menu-samping">
                        <Link to="/" className="beranda-sambutan">👈 Kembali ke beranda</Link>
                        <div className="menu-kanan" style={{ cursor: "pointer" }}>
                            <div className={`nav-kanan ${activeMenu === 'sambutan' ? 'clicked' : ''}`} onClick={showKepsekContent}>Sambutan</div>
                            <div className={`nav-kanan ${activeMenu === 'tentang' ? 'clicked' : ''}`} onClick={showSmalabumContent}>Tentang SMA Lab UM</div>
                            <div className="nav-kanan">Struktur Organigram</div>
                            <div className="nav-kanan">Guru & Karyawan</div>
                            <div className="nav-kanan">Statistika</div>
                            <div className="nav-kanan">Logo</div>
                        </div>
                        <div className="sidebar-kanan">
                            <Sidebar
                                onSambutanClick={showKepsekContent}
                                onTentangClick={showSmalabumContent}
                            />
                        </div>
                    </div>
                    <div className="isi">
                        {showKepsek && (
                            <>
                                <h1 className="kepsek">Kepala Sekolah SMA Lab UM</h1>
                                <p className="salam">Salam budaya,
                                    <br></br>
                                    Puji syukur ke hadirat Allah swt kami dapat hadir untuk turut mencerdaskan kehidupan bangsa. Sebagaimana moto kami MAPRAJNA WANGCA APATYA (mencerdaskan anak bangsa), dengan bangga kami bertekad memberikan pelayanan pendidikan dengan penuh dedikasi, transparan, komunikatif, edukatif dan berkarakter Indonesia.
                                    <br></br>
                                    <br></br>
                                    Informasi yang kami sajikan dalam web ini merupakan ajang bagi kami untuk mempublikasikan hasil karya segenap civitas akademika SMA Laboratorium UM. Selain itu, beberapa pengetahuan umum, pembelajaran online, forum interaktif , dan informasi kegiatan sekolah dapat dinikmati dalam rubrik-rubrik dan kolom-kolom web ini.
                                    <br></br>
                                    <br></br>
                                    Semoga dengan layanan ini kualitas pembelajaran dan komunikasi dapat berjalan dengan lancar dan mencapai sasaran. Khususnya dalam mengaktulisasikan Visi sekolah terwujudnya sekolah yang memiliki civitas akademika yang beriman, bertakwa, berakhlak mulia, berprestasi akademik dan nonakademik dan berkepedulian sosial.
                                </p>
                                <div>
                                    <div className="next-menu" style={{ textDecoration: "none", color: "black", cursor: "pointer" }} onClick={showSmalabumContent}>Berikutnya <img src="../../assets/hero/right.svg"></img></div>
                                </div>

                            </>
                        )}


                        {showSmalabum && (
                            <>
                                <h1 className="kepsek">Sejarah SMA Lab UM</h1>
                                <img src="../../assets/navbar/logo-smalabum.svg" className="logo-smalabum"></img>
                                <p className="salam ikip">SMA Laboratorium adalah merupakan salah satu sekolah laboratorium yang berada dalam naungan Universitas Negeri Malang (d.h. IKIP Negeri Malang). Adapun selain sekolah-sekolah laboratorium meliputi; TK Laboratorium, SD Laboratorium, SD Berkebutuhan khusus, SMP Laboratorium dan SMA Laboratorium UM. Sekolah-sekolah Laboratorium tersebut bertanggung jawab terhadap Rektor Universitas Negeri Malang melalui UPT P2LP (Pusat Pengembangan Laboratorium Pendidikan).
                                    SMA Laboratorium UM berdiri dan mulai beroperasi pada tahun 1994 dengan nama SMA IKIP Negeri Malang.
                                    <br></br>
                                    <br></br>
                                    Sejak awal berdiri hingga sekarang SMA Laboratorium UM sudah dipimpin oleh 6 orang Kepala Sekolah:
                                    <br></br>
                                    <br></br>
                                    <span className="guru">
                                        Bapak Drs. H.A. Rosyid Al Atok, M.Pd, M.H Tahun 1994 - 1997
                                        <br></br>
                                        Bapak Drs. Muhardjito, M.S. Tahun 1997 - 2003
                                        <br></br>
                                        Bapak Drs. H. Ridwan Joharmawan, M.Si. Tahun 2003 - 2012
                                        <br></br>
                                        Ibu DR. Hj. Muslihati, S.Ag, M.Pd. Tahun 2012 - 2013
                                        <br></br>
                                        Bapak DR. Tri Kuncoro, S.T, M.Pd. Tahun 2013 - 2015
                                        <br></br>
                                        Ibu Rosdiana Amini, M.Pd. Tahun 2015 - Sekarang.
                                    </span>
                                </p>


                                <h1 className="kepsek visi">Visi & Misi</h1>
                                <p className="salam visi" style={{ fontWeight: "bold" }}>Visi</p>
                                <p className="salam unggul">Sebagai Sekolah Unggul Pencetak Lulusan yang Beriman, Bertaqwa, Berakhlaq Mulia & Berprestasi</p>
                                <p className="salam misi" style={{ fontWeight: "bold" }}>Misi</p>

                                <ol>
                                    {data.map((item, index) => (
                                        <li key={index} className="salam unggul">
                                            {item.misi}
                                        </li>
                                    ))}
                                </ol>



                                <div className="petunjuk d-flex justify-content-between align-items-start">
                                    <div className="next-menu" style={{ textDecoration: "none", color: "black" }}><img src="../../assets/hero/right.svg" style={{ transform: "rotate(180deg)", marginRight: "5px", cursor: "pointer" }} onClick={showKepsekContent}></img>
                                        Sebelumnya</div>

                                    <div className="next-menu" style={{ textDecoration: "none", color: "black" }}>Berikutnya <img src="../../assets/hero/right.svg"></img></div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </section>
            <div className="bawah-sam">
            <Copyright />
        </div>

        </>

    )
}
